import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import { TESTIMONIALS } from "../data/content";

export const Testimonials = () => (
  <section id="testimoni" data-testid="testimonials-section" className="relative py-28 lg:py-36">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <motion.p
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        className="font-mono-arch text-[11px] tracking-[0.35em] uppercase text-brass mb-5"
      >
        Kata Mereka
      </motion.p>
      <motion.h2
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1], delay: 0.1 }}
        className="font-serif-lux font-light text-3xl sm:text-4xl lg:text-5xl text-bone tracking-tight leading-[1.12]"
      >
        Kepercayaan adalah<br />material terkuat kami.
      </motion.h2>

      <div className="mt-16 grid md:grid-cols-3 gap-5">
        {TESTIMONIALS.map((t, i) => (
          <motion.figure
            key={t.name}
            data-testid={`testimonial-${i + 1}`}
            initial={{ opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1], delay: i * 0.14 }}
            className="bg-surface border border-white/5 hover:border-[rgba(197,160,89,0.3)] transition-colors duration-500 p-8 flex flex-col"
          >
            <Quote className="w-6 h-6 text-brass" strokeWidth={1.4} />
            <blockquote className="font-serif-lux text-lg lg:text-xl text-bone/90 leading-relaxed mt-6 flex-1 italic">
              “{t.quote}”
            </blockquote>
            <figcaption className="mt-8 pt-6 border-t border-white/10">
              <p className="text-sm text-bone">{t.name}</p>
              <p className="font-mono-arch text-[10px] tracking-[0.2em] uppercase text-dim mt-1.5">{t.role}</p>
            </figcaption>
          </motion.figure>
        ))}
      </div>
    </div>
  </section>
);
